// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { chain, LoadCart } from "@insite/client-framework/Store/Pages/Cart/Handlers/UpdateCartLine";

export const XngLoadCart: any = (props: any) => {
    const showTaxAndShipping = props.parameter.showTaxAndShipping;
    props.dispatch(loadCurrentCart({ showTaxAndShipping } as any));
    props.parameter.shouldNotLoadFullCart
        ? props.dispatch(
              loadCurrentCart({
                  shouldLoadFullCart: false,
                  getCartLines: true,
                  getCostCodes: true,
                  showTaxAndShipping,
                  getPromotions: !props.parameter.shouldNotReloadPromotions,
              } as any),
          )
        : props.dispatch(
              loadCurrentCart({ showTaxAndShipping, getPromotions: !props.parameter.shouldNotReloadPromotions } as any),
          );
};

replaceInChain(chain, LoadCart, XngLoadCart);
